import { Carousel } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCommunityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const StyledRegisteredUsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 24.4rem;
  z-index: 1;
`;

export const StyledRegisteredUsersNumber = styled.span`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 5.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.primary.main};
  margin-top: 5rem;
`;

export const StyledRegisteredUsersText = styled.span`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 3.6rem;
  color: ${({ theme }) => theme.colors.grey[900]};
`;

export const StyledCarouselContainer = styled.div`
  display: flex;
  margin-top: 4.6rem;
`;

export const StyledCarousel = styled(Carousel)`
  width: 100%;

  > div:first-of-type {
    min-height: 39rem;
  }
`;

export const StyledTopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 20rem;
  }
`;

export const StyledTitleAndDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledRegisteredUsersAndCloudWrapper = styled.div`
  display: flex;
`;

export const StyledCloudWrapper = styled.div`
  display: flex;
  margin-top: -0.6rem;
  margin-left: -23rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.sm}) {
    margin-left: -13rem;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  padding: 1.8rem;
`;

export const StyledImageContainer = styled.div`
  margin: 0 auto;
  height: 17rem;
  max-width: 33.4rem;
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.boxShadow.light};

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    max-width: 41.4rem;
  }
`;
